const navigation = document.querySelector('.navigation');
const menuItemsWithSubmenu = document.querySelectorAll('.has-submenu');

if (navigation) {
    menuItemsWithSubmenu.forEach((menuItem) => {
        const submenu = menuItem.querySelector('.submenu');
        const linkThatHasSubmenu = menuItem.querySelector(':scope > a');

        /**
         * Desktop / :
         */
        
        menuItem.addEventListener('click', () => {
            if (submenu.classList.contains('active')) {
                submenu.classList.remove('active');
            } else {
                submenu.classList.add('active');
            }
        });
        
        menuItem.addEventListener('focusout', () => {
            submenu.classList.remove('active');
        });

        /**
         * Mobile:
         */
        linkThatHasSubmenu.addEventListener('click', (e) => {
            const isMobile = window.matchMedia('(max-width: 1125px)').matches;
            if (isMobile) {
                e.stopPropagation();
                menuItem.classList.toggle('mobile-active');
            }
        });

        linkThatHasSubmenu.addEventListener('click', (e) => {
            const isMobile = window.matchMedia('(max-width: 1125px)').matches;
            if (isMobile) {
                e.preventDefault(); // On mobile, clicking on a link that has a submenu does function as regular link anymore, but is only used to toggle its submenu on click.
            }
        });
    });
}
